export default __webpack_public_path__ + "static/media/Loader-new.593f004c.gif";